import AdminPage from "../components/admin/AdminPage";

export default function AdminPageRoute() {
  return <AdminPage />;
}
